var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.38219 24 0 18.6178 0 12C0 5.38219 5.38219 0 12 0C18.6178 0 24 5.38219 24 12C24 18.6178 18.6178 24 12 24ZM12 1.28838C6.09454 1.28838 1.28838 6.09454 1.28838 12C1.28838 17.9055 6.09454 22.7116 12 22.7116C17.9055 22.7116 22.7116 17.9055 22.7116 12C22.7116 6.09454 17.9055 1.28838 12 1.28838Z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1181 12.0567V19.0131C10.1181 19.1142 10.1972 19.1934 10.2984 19.1934H12.8795C12.9807 19.1934 13.0598 19.1142 13.0598 19.0131V11.9423H14.933C15.0254 11.9423 15.1045 11.872 15.1133 11.7753L15.2936 9.647C15.3024 9.54147 15.2189 9.44912 15.1133 9.44912H13.0598V7.93648C13.0598 7.58031 13.3456 7.29449 13.7018 7.29449H15.1441C15.2452 7.29449 15.3244 7.21534 15.3244 7.1142V4.98595C15.3244 4.88482 15.2452 4.80566 15.1441 4.80566H12.7037C11.2746 4.80566 10.1137 5.96653 10.1137 7.39562V9.44912H8.82091C8.71978 9.44912 8.64062 9.52827 8.64062 9.62941V11.7577C8.64062 11.8588 8.71978 11.9379 8.82091 11.9379H10.1137V12.0567H10.1181Z",
    fill: "#C8C8C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.3fa42e01.svg";
export { ForwardRef as ReactComponent };